export default "__VITE_ASSET__C9fe2QA6__"